import { useEffect } from 'react';

export function usePreloadImage(src: string) {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    link.type = 'image/webp';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, [src]);
}
